import CancelIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import {
  GridActionsCell,
  GridActionsCellItem,
  GridRowModes,
  type GridRenderCellParams,
  type GridRowId,
  useGridApiContext
} from '@mui/x-data-grid';
import React from 'react';

type ActionsCellProps = GridRenderCellParams & {
  onCancel: (id: GridRowId) => void;
  onDelete?: (id: GridRowId) => void;
  onEdit: (id: GridRowId) => void;
  onSave: (id: GridRowId) => void;
};

const ActionsCell = (props: ActionsCellProps) => {
  const apiRef = useGridApiContext();
  const isInEditMode = apiRef.current.getRowMode(props.id) === GridRowModes.Edit;
  const { onCancel, onDelete, onEdit, onSave, ...cellProps } = props;

  return (
    <GridActionsCell {...cellProps}>
      {isInEditMode ? (
        <React.Fragment>
          <GridActionsCellItem
            icon={<SaveIcon />}
            label="Save"
            material={{ sx: { color: 'primary.main' } }}
            onClick={() => onSave(props.id)}
          />
          <GridActionsCellItem
            icon={<CancelIcon />}
            label="Cancel"
            className="textPrimary"
            onClick={() => onCancel(props.id)}
            color="inherit"
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={() => onEdit(props.id)}
            color="inherit"
          />
          {onDelete && (
            <GridActionsCellItem
              icon={<DeleteIcon />}
              label="Delete"
              onClick={() => onDelete(props.id)}
              color="inherit"
            />
          )}
        </React.Fragment>
      )}
    </GridActionsCell>
  );
};

export default ActionsCell;
